/**
 * Runtime configuration (CI/CD spec §3.4).
 *
 * The bundle is environment-agnostic: it fetches config.json from its own origin at
 * boot, so the same bytes serve dev and prod and no environment value is ever baked
 * into a hashed asset that CloudFront would then cache for a year.
 *
 * Everything here is public by definition — it is served to browsers.
 */
export interface AppConfig {
  environment: string
  apiBaseUrl: string
  userPoolId: string
  userPoolClientId: string
  siteUrl: string
  /** Where abuse reports go. Optional so an older config.json still loads. */
  abuseEmail?: string
}

let cached: AppConfig | null = null

export async function loadConfig(): Promise<AppConfig> {
  if (cached) return cached
  const response = await fetch('/config.json', { cache: 'no-store' })
  if (!response.ok) throw new Error(`could not load configuration (${response.status})`)
  cached = (await response.json()) as AppConfig
  return cached
}

export function setConfig(config: AppConfig | null): void {
  cached = config
}
